import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import { GetTaskListRep } from '../task-repository';
import { AbstractTaskServiceImpl } from './abstract-task-service';
import type { TaskService } from '../task-service';
import type { TaskQueryParams } from '../../types';

@injectable()
export class TaskServiceImpl extends AbstractTaskServiceImpl<TaskQueryParams> implements TaskService {
    constructor(
        @inject(GetTaskListRep)
        private _getTaskListRep: GetTaskListRep,
    ) {
        super();
    }

    public async fetchTaskList(params: TaskQueryParams) {
        return this._getTaskListRep.fetch(params);
    }
}
